import { combineReducers } from 'redux';
import readReservationsOccupancyInsightsData from 'store/reducers/occupancy-insights/readReservationsOccupancyInsightsData';
import readOccupancyInsightsFilters from 'store/reducers/occupancy-insights/readOccupancyInsightsFilters';
import occupancyInsightsTableFilters from 'store/reducers/occupancy-insights/occupancyInsightsTableFilters';
import readReservationOccupancyInsightsData from 'store/reducers/occupancy-insights/readReservationOccupancyInsightsData';

export default combineReducers({
  readReservationsOccupancyInsightsData,
  readOccupancyInsightsFilters,
  occupancyInsightsTableFilters,
  readReservationOccupancyInsightsData,
});
